export const ADDITIONAL_ROUTE = "/additionals";

export const HOME_PAGES_ROUTES = {
  HOME_PAGE: "/",
};

export const SIGNIN_PAGES_ROUTES = {
  SIGNIN_PAGE: "/signin",
};

export const ADDITIONALS_ROUTES = {
  ADDITIONALS_DETAIL: "/:additionalsId",
  ADDITIONALS_PREVIEW: "/preview/:additionalsId",
};

export const TESTS_ROUTES = {
  TEST_PAGE: "/:additionalsId/test/:chapterId",
};

export const STM_ROUTE = "/courses";
